import baseService from './baseService';
import config from '../../config';

export default{
    getProperties(params) {
        return baseService.get(config.API_LOCATION + 'property',params)
    },
    getMapMarks(params){
        return baseService.get(config.API_LOCATION + 'property/map',params)
    },
    getNearBy(params){
        return baseService.get(config.API_LOCATION + 'property/nearBy',params)  
    },
    getById(id){
        return baseService.get(config.API_LOCATION + 'property/' + id,{})
    },
    getByCoordinates(params){
        return baseService.get(config.API_LOCATION + 'property/coordinates',params)
    },
    favorite(id,params){
        return baseService.post(config.API_LOCATION + 'property/favorite/' +  id,params)
    },
    region(id,params){
        return baseService.get(config.API_LOCATION + 'list/regions/' + id,params)
    },
    city(id,params){
        return baseService.get(config.API_LOCATION + 'list/cities/' + id, params)
    },
    sendEnquire(id, params){
        return baseService.post(config.API_LOCATION + 'property/' + id + '/enquire', params)
    },
    sendGuestEnquire(id, params){
        return baseService.post(config.API_LOCATION + 'property/' + id + '/enquire/guest', params)
    },
    getHotProperties(params){
        return baseService.get(config.API_LOCATION + 'property/hot', params)
    },
    print(id,params){
        return baseService.get(config.API_LOCATION + 'property/' + id + '/print',params,'arraybuffer')
    }


}

